import React, { useCallback, useEffect, useMemo, useState } from "react";
import { connect } from "dva";
import { useTranslation } from "react-i18next";
import ChatState from "@/types/chat/State";
import { Employee, Session } from "@/types/chat";
import { Modal, message as toast, Input } from "antd";
import ComNoticeCard from "@/baseComponents/ComNoticeCard";
import { changeEgovUrl } from "@/utils/tools";
import { EbookState, MangeExternalModalInfo } from "@/models/ebook";
import AccountDelay from "@/components/AccountDelay";
import config, { ConfigEnum } from "@/config/config";
import { approveAccountEXP } from "@/api/ebook";
import { setManageNoticeTipsTool } from "@/utils/chat/index";
import IconFont from "@/components/icon";

const ExternalAccountDelayCard = connect(
  function ({ chat, ebook }: { chat: ChatState; ebook: EbookState }) {
    const { selectedSession } = chat;
    const { manageExternalModal } = ebook;
    return {
      selectedSession,
      manageExternalModal
    };
  },
  function (dispatch: any) {
    return {
      setManageExternalModal(payload: any) {
        dispatch({ type: "ebook/setManageExternalModal", payload });
      }
    };
  }
)(function ({
  message,
  setManageExternalModal,
  manageExternalModal
}: {
  message: any;
  manageExternalModal: MangeExternalModalInfo;
  setManageExternalModal: Function;
}) {
  const { t } = useTranslation("chat");
  const { title, content, infox, extend } = message;
  const [visibleAccountDelay, setVisibleAccountDelay] = useState(false);
  const [AccountDelayTitle, setAccountDelayTitle] = useState("");
  const [controller, setController] = useState(false);
  console.log(1111111, extend.btns, message);
  // 审核通过
  const approvedAction = useCallback(() => {
    Modal.confirm({
      title: "提示",
      className: "manage-external-modal",
      content: (
        <>
          确定对该账号进行延期？
          <p className="confirmCon">延期后，账号有效期增加6个月</p>
        </>
      ),
      okText: "确定",
      cancelText: "取消",
      async onOk() {
        const [result, error] = await approveAccountEXP({
          recordId: message?.extend?.recordId, // AI卡片里审核在extend中, 消息通知列表里参见返回的字段
          result: 1, // 0:驳回, 1:通过
          apprOption: ""
        });
        if (error) {
          toast.error(error);
          return;
        }
        const { status } = result;
        setManageNoticeTipsTool(status);
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const doSwitchAccountDelay = useCallback(() => {
    setVisibleAccountDelay(!visibleAccountDelay);
  }, [visibleAccountDelay]);

  const handleClick = useCallback(
    (btn) => {
      // 管理者     已通过：'extEmplApplyHasBeenPassed'
      //            已失效：'extEmplApplyUnvalid'
      //            已驳回：'extEmplApplyHasBeenRejectd'
      //            驳回：'extEmplApplyHasBeenRejectd'
      //            通过："extEmplApplyPass"
      // 外部联系人 申请延期：'extEmplDelayApply'

      switch (btn.action) {
        // case 'extEmplApplyHasBeenPassed':
        //     return approvedAction();
        case "extEmplDelayApply": // "申请延期"
          setController(false);
          setAccountDelayTitle("请填写申请原因");
          doSwitchAccountDelay();
          return;
        case "extEmplApplyReject": // 驳回
          setController(true);
          setAccountDelayTitle("请填写驳回原因");
          doSwitchAccountDelay();
          return;
        case "extEmplApplyPass": // 通过
          return approvedAction();
      }
    },
    [approvedAction, doSwitchAccountDelay]
  );

  const doShowAccountDelay = useCallback(
    (type) => {
      setManageExternalModal({ ...manageExternalModal, ...type });
    },
    [manageExternalModal, setManageExternalModal]
  );

  return (
    <>
      <ComNoticeCard
        message={message}
        avatarSrc={changeEgovUrl(message.sender.avatar)}
        type={extend.applicationName}
        contentList={extend.fields}
        title={title}
        handleDetail={() => {
          if (config[ConfigEnum.EXTERNAL_CONTACTS_ADD_CONTACTS]) {
            // doShowAccountDelay({ manageNoticeListVisible: true });
          } else {
            doShowAccountDelay({ externalApplyVisible: true });
          }
        }}
        loadButtonsFn={
          extend?.btns?.length > 0
            ? () => {
                return (
                  <div className="button_items">
                    {extend.btns.map((btn: any, idx: number) => {
                      return (
                        <button
                          className=""
                          key={idx}
                          onClick={() => handleClick(btn)}
                          disabled={
                            btn.action === "extEmplApplyHasBeenPassed" ||
                            btn.action === "extEmplApplyUnvalid" ||
                            btn.action === "extEmplApplyHasBeenRejectd"
                              ? true
                              : false
                          }
                          style={{
                            color:
                              btn.action === "extEmplApplyHasBeenPassed" ||
                              btn.action === "extEmplApplyUnvalid" ||
                              btn.action === "extEmplApplyHasBeenRejectd"
                                ? "#8F959EFF"
                                : "",
                            cursor:
                              btn.action === "extEmplApplyHasBeenPassed" ||
                              btn.action === "extEmplApplyUnvalid" ||
                              btn.action === "extEmplApplyHasBeenRejectd"
                                ? "default"
                                : "pointer"
                          }}
                        >
                          {btn.action === "extEmplApplyHasBeenPassed" && (
                            <IconFont
                              type="iconlog_message"
                              style={{ color: "#00A645", marginRight: 6 }}
                            />
                          )}
                          {["extEmplApplyUnvalid", "extEmplApplyHasBeenRejectd"].includes(
                            btn.action
                          ) && (
                            <IconFont
                              type="iconlog_message"
                              style={{ color: "#EE0A24", marginRight: 6 }}
                            />
                          )}
                          {btn.name}
                        </button>
                      );
                    })}
                  </div>
                );
              }
            : null
        }
      />
      {visibleAccountDelay && (
        <AccountDelay
          visible={visibleAccountDelay}
          onCancel={doSwitchAccountDelay}
          title={AccountDelayTitle}
          controller={controller}
          messageData={message}
        />
      )}
    </>
  );
});

export default ExternalAccountDelayCard;
